
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/vendor-application/faq",
      function () {
        return require("private-next-pages/app/vendor-application/faq/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/vendor-application/faq"])
      });
    }
  